import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosUser } from "../axios";
import type { IFindUsersQuery, TFindUsersResponse } from "./types";

export const useFindUsersInternal = () => {
  const [state, execute, cancel] = axiosUser<TFindUsersResponse, void, unknown>(
    {
      url: "/internal",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (query?: IFindUsersQuery & { teams?: ObjectId[] }) => {
      return execute({
        params: query,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
